module.exports = new Promise((resolve, reject) => {
          const envUrl = window._env_?.AI_AGENT_HUB_URL;
          const isDev = !envUrl || envUrl.startsWith('$');
          const remoteUrl = isDev ? 'http://localhost:3005' : envUrl;

          if (true && isDev) {
            console.error('[Module Federation] AI_AGENT_HUB_URL not configured for production');
            reject(new Error('AI Agent Hub MFE is not configured'));
            return;
          }

          const script = document.createElement('script');
          script.src = remoteUrl + '/remoteEntry.js?v=' + Date.now();
          script.onload = () => {
            resolve(window.aiAgentHub);
          };
          script.onerror = () => {
            console.error('[Module Federation] Failed to load aiAgentHub remote from:', remoteUrl);
            reject(new Error('Failed to load AI Agent Hub MFE'));
          };
          document.head.appendChild(script);
        });